// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CatalogProduct__Queries from "./CatalogProduct__Queries.res.js";

function makeFilterBy(activeShopId) {
  return CatalogProduct__Queries.ProductQuery.makeInputObjectInputProductsByVariantCkuQueryFilter(activeShopId !== undefined ? CatalogProduct__Queries.ProductQuery.makeInputObjectInFilter([activeShopId], undefined) : undefined, "INCLUDED", undefined);
}

function formatValueFromVariantPrice(param) {
  let variantPrice = param.node;
  let match = Stdlib_Option.map(variantPrice.price, price => price.taxIncluded);
  let price = match !== undefined ? (
      match ? variantPrice.valueIncludingTax : variantPrice.valueExcludingTax
    ) : undefined;
  return Stdlib_Option.mapOr(price, "—", price => I18n.currencyFormat(undefined, "EUR", undefined, undefined, price));
}

function retailPriceFromVariantPrices(prices) {
  return Stdlib_Option.mapOr(prices.find(param => Stdlib_Option.mapOr(param.node.price, false, price => price.enableByDefault)), "—", formatValueFromVariantPrice);
}

function productsInformationFromData(data) {
  return data.productsByVariantCku.edges.map(param => {
    let data = param.node;
    return {
      id: data.id,
      status: Stdlib_Option.map(data.formattedStatus, status => {
        if (status === "ARCHIVED") {
          return {
            TAG: "Archived",
            _0: data.archivedAt
          };
        } else if (status === "ACTIVE") {
          return "Active";
        } else {
          return "Inactive";
        }
      }),
      name: data.name,
      description: data.formattedDescription,
      formattedOrigin: data.formattedOrigin,
      taxValue: data.tax.value,
      categoryId: Stdlib_Option.map(data.category, param => param.id),
      formattedCategoryName: Stdlib_Option.mapOr(data.category, I18n.t("Not classified"), param => param.formattedName),
      shopId: data.shop.id,
      shopName: data.shop.name,
      internalNote: Stdlib_Option.getOr(data.internalNote, "")
    };
  });
}

function productsVariantsFromData(data) {
  return data.productsByVariantCku.edges.map(param => param.node.variants.edges.toSorted((param, param$1) => param$1.node.name.localeCompare(param.node.name)).map(param => {
    let variant = param.node;
    let match = variant.formattedStatus;
    let match$1 = variant.capacityUnit;
    let match$2 = Stdlib_Option.getOr(variant.bulk, false);
    return {
      cku: variant.cku,
      id: variant.id,
      shopName: variant.shop.name,
      status: match === "INACTIVE" ? "Inactive" : (
          match === "ARCHIVED" ? ({
              TAG: "Archived",
              _0: variant.archivedAt
            }) : (
              match === "ACTIVE" ? "Active" : undefined
            )
        ),
      name: variant.name,
      formattedPurchasePrice: variant.formattedPurchasedPrice,
      purchasePrice: Stdlib_Option.getOr(variant.purchasedPrice, 0),
      formattedRetailPrice: retailPriceFromVariantPrices(variant.variantPrices.edges),
      retailPrices: Stdlib_Array.filterMap(variant.variantPrices.edges, variantPrice => {
        let price = variantPrice.node.price;
        if (price !== undefined) {
          return {
            name: price.name,
            formattedValue: formatValueFromVariantPrice(variantPrice),
            taxIncluded: price.taxIncluded,
            default: price.enableByDefault
          };
        }
      }),
      bulkUnit: match$1 !== undefined && match$2 ? match$1 : undefined,
      stock: {
        quantity: variant.stock.formattedQuantity,
        state: variant.stock.state
      },
      maxStockThreshold: Stdlib_Option.getOr(variant.maxStockThreshold, 0),
      minStockThreshold: Stdlib_Option.getOr(variant.minStockThreshold, 0),
      stockOrderTriggerThreshold: Stdlib_Option.getOr(variant.stockOrderTriggerThreshold, 0),
      bulk: Stdlib_Option.getOr(variant.bulk, false)
    };
  }));
}

let Query;

export {
  Query,
  makeFilterBy,
  formatValueFromVariantPrice,
  retailPriceFromVariantPrices,
  productsInformationFromData,
  productsVariantsFromData,
}
/* I18n Not a pure module */
